import { _ as _defineProperty, g as getValueByPath } from './helpers-d639255d.js';
import { B as BaseComponentMixin, c as config, n as normalizeComponent } from './plugins-4295ce0e.js';
import { _ as __vue_component__$1 } from './Icon-9c764942.js';
import { F as FormElementMixin } from './FormElementMixin-f9847bcc.js';

/**
 * Select an item in a dropdown list. Use with Field to access all functionalities
 * @displayName Select
 * @example ./examples/Select.md
 * @style _select.scss
 */

var script = {
  name: 'OSelect',
  components: _defineProperty({}, __vue_component__$1.name, __vue_component__$1),
  mixins: [BaseComponentMixin, FormElementMixin],
  inheritAttrs: false,
  provide: function provide() {
    return {
      $elementRef: 'select'
    };
  },
  props: {
    /**
     * @model
     */
    value: {
      type: [String, Number, Boolean, Object, Array],
      default: null
    },

    /**
     * Vertical size of input, optional
     * @values small, medium, large
     */
    size: String,

    /**
     * 	Icon name to be added on the right side
     */
    iconRight: {
      type: String,
      default: function _default() {
        return getValueByPath(config, 'select.iconRight', 'caret-down');
      }
    },

    /** Text when nothing is selected */
    placeholder: String,
    multiple: Boolean,

    /** Same as native size */
    nativeSize: [String, Number],
    rootClass: String,
    controlExpandedClass: String,
    controlIconLeftClass: String,
    controlIconRightClass: String,
    roundedClass: String,
    multipleClass: String,
    emptyClass: String,
    expandedClass: String,
    iconLeftClass: String,
    iconRightClass: String,
    sizeClass: String,
    variantClass: String
  },
  data: function data() {
    return {
      selected: this.value
    };
  },
  computed: {
    rootClasses: function rootClasses() {
      return [this.computedClass('select', 'rootClass', 'o-control-select'), _defineProperty({}, this.computedClass('select', 'controlExpandedClass', 'o-control-select-expanded'), this.expanded), _defineProperty({}, this.computedClass('select', 'controlIconLeftClass', 'o-control-select-icons-left'), this.icon), _defineProperty({}, this.computedClass('select', 'controlIconRightClass', 'o-control-select-icons-right'), this.iconRight)];
    },
    selectClasses: function selectClasses() {
      return [this.computedClass('select', 'selectClass', 'o-select'), _defineProperty({}, this.computedClass('select', 'roundedClass', 'o-select-rounded'), this.rounded), _defineProperty({}, this.computedClass('select', 'emtpyClass', 'o-select-empty'), this.selected === null), _defineProperty({}, this.computedClass('select', 'multipleClass', 'o-select-multiple'), this.multiple), _defineProperty({}, this.computedClass('select', 'expandedClass', 'o-select-expanded'), this.expanded), _defineProperty({}, "".concat(this.computedClass('select', 'sizeClass', 'o-size-')).concat(this.size), this.size), _defineProperty({}, "".concat(this.computedClass('select', 'variantClass', 'o-color-')).concat(this.statusVariant), this.statusVariant)];
    },
    iconLeftClasses: function iconLeftClasses() {
      return [this.computedClass('select', 'iconLeftClass', 'o-icon-left')];
    },
    iconRightClasses: function iconRightClasses() {
      return [this.computedClass('select', 'iconRightClass', 'o-icon-right')];
    },
    computedValue: {
      get: function get() {
        return this.selected;
      },
      set: function set(value) {
        this.selected = value;
        this.$emit('input', value);
        !this.isValid && this.checkHtml5Validity();
      }
    }
  },
  watch: {
    /**
    * When v-model is changed:
    *   1. Set the selected option.
    *   2. If it's invalid, validate again.
    */
    value: function value(_value) {
      this.selected = _value;
      !this.isValid && this.checkHtml5Validity();
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: _vm.rootClasses },
    [
      _c(
        "select",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.computedValue,
                expression: "computedValue"
              }
            ],
            ref: "select",
            class: _vm.selectClasses,
            attrs: { multiple: _vm.multiple, size: _vm.nativeSize },
            on: {
              blur: function($event) {
                _vm.$emit("blur", $event) && _vm.checkHtml5Validity();
              },
              focus: function($event) {
                return _vm.$emit("focus", $event)
              },
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value;
                    return val
                  });
                _vm.computedValue = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0];
              }
            }
          },
          "select",
          _vm.$attrs,
          false
        ),
        [
          _vm.placeholder
            ? [
                _vm.computedValue == null
                  ? _c(
                      "option",
                      {
                        attrs: { disabled: "", hidden: "" },
                        domProps: { value: null }
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.placeholder) +
                            "\n            "
                        )
                      ]
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      ),
      _vm._v(" "),
      _vm.icon
        ? _c("o-icon", {
            class: _vm.iconLeftClasses,
            attrs: { icon: _vm.icon, pack: _vm.iconPack, size: _vm.size }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.iconRight
        ? _c("o-icon", {
            class: _vm.iconRightClasses,
            attrs: {
              icon: _vm.iconRight,
              pack: _vm.iconPack,
              size: _vm.size,
              both: ""
            }
          })
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as _ };
